import formatPhone from '@glass/common/modules/utils/formatPhone';

export const SUPPORT_TWITTER = 'TheRocketResume';
export const SUPPORT_PHONE = '18885868975';
export const SUPPORT_PHONE_FORMATTED = formatPhone(SUPPORT_PHONE);
export const SUPPORT_EMAIL = 'support@rocket-resume.com';
export const SUPPORT_HOURS = 'Monday - Friday, 8a - 8p CST and 12p - 4p on weekends';
